import {createEventBus} from '@malt/vue-event-bus/src/create-event-bus';

export interface MissionEventModal {
    id: string;
    data: any;
    options: any;
}

type Events = {
    'missions-events:modal:open': MissionEventModal;
    'missions-events:modal:closed': MissionEventModal;
};

export const eventBus = createEventBus<Events>();
